import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "operators" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "first-column-with-icon-type" }
const _hoisted_6 = { class: "name-type-block" }
const _hoisted_7 = { class: "name-data" }
const _hoisted_8 = { class: "first-column-with-icon-type" }
const _hoisted_9 = { class: "name-type-block" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "first-column-with-icon-type" }
const _hoisted_12 = { class: "name-type-block" }
const _hoisted_13 = { class: "name-data" }
const _hoisted_14 = { class: "type-data-mini" }
const _hoisted_15 = { class: "first-column-with-icon-type" }
const _hoisted_16 = { class: "name-type-block" }
const _hoisted_17 = { class: "name-data" }
const _hoisted_18 = { class: "type-data-mini" }
const _hoisted_19 = { class: "first-column-with-icon-type" }
const _hoisted_20 = { class: "name-type-block" }
const _hoisted_21 = { class: "name-data" }
const _hoisted_22 = { class: "type-data-mini" }
const _hoisted_23 = { class: "emq-table-footer" }

import { getProfitsharingTransactionList } from '@/api/operation'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import { dateFormat } from '@/common/tools'
import PreWithEllipsis from '@/components/PreWithEllipsis.vue'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { ArrowUp, ArrowDown, Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { Ref, onActivated } from 'vue'
import SelectOperator from '@/components/SelectOperator.vue'
import LinkOperator from '@/components/Links/LinkOperator.vue'
import LinkOrder from '@/components/Links/LinkOrder.vue'
import SelectPayee from '@/components/SelectPayee.vue'


import { defineComponent, ref } from 'vue'
import { useRoute } from 'vue-router'

const __default__ = defineComponent({
  name: 'Transactions',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  orderId: {
    type: String,
    default: '0',
    required: false,
  },
  showQueryFilter: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props

const route = useRoute()

const { t } = useI18nTl('Order')



const showMoreQuery = ref(false)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const {
  getProfitSharingTransactionTypeDesc,
  getProfitSharingTradeStateDesc,
  getProfitSharingSourceDesc,
} = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('operators-detail')

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadTableData({ page: 1 })
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { id, walletName, operatorId, orderId, walletId } = params
  newParams = {
    id: id || undefined,
    walletName: walletName || undefined,
    operatorId: operatorId || undefined,
    orderId: orderId || undefined,
    walletId: walletId || undefined,
  }

  return newParams
}

const loadTableData = async (_params = {}) => {
  lockTable.value = true

  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
      ..._params,
    },
  }


  if (props.orderId !== '0' && sendParams.orderId != props.orderId) {
    sendParams.orderId = props.orderId
  }

  if (route.query && route.query.orderId &&
    (sendParams.orderId == '' || sendParams.orderId == '0' || sendParams.orderId == undefined)) {
    fuzzyParams.value.orderId = route.query.orderId
    sendParams.orderId = route.query.orderId
  }

  try {
    const { list = [], pageReply = {} } = await getProfitsharingTransactionList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}

// onActivated(() => {
//   const { query } = useRoute()
//   if (query.orderId) {
//     fuzzyParams.value.orderId = query.orderId
//   }
//   handleSearch()
// })

loadTableData()

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.showQueryFilter)
      ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          class: "search-wrapper",
          onKeyup: _withKeys(handleSearch, ["enter"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(SelectOperator, {
                      modelValue: fuzzyParams.value.operatorId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.operatorId) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(SelectPayee, {
                      modelValue: fuzzyParams.value.walletId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.walletId) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: fuzzyParams.value.orderId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.orderId) = $event)),
                      placeholder: _ctx.$t('Order.orderID'),
                      clearable: "",
                      onClear: handleSearch
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 16),
                (showMoreQuery.value)
                  ? (_openBlock(), _createBlock(_component_el_col, _normalizeProps(_mergeProps({ key: 0 }, _unref(colProps))), {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: fuzzyParams.value.id,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fuzzyParams.value.id) = $event)),
                          placeholder: _ctx.$t('Base.id'),
                          clearable: "",
                          onClear: handleSearch
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 16))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      plain: "",
                      icon: _unref(Search),
                      onClick: handleSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_button, {
                      icon: _unref(RefreshLeft),
                      onClick: handleReset
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_tooltip, {
                      content: !showMoreQuery.value ? _ctx.$t('Base.showMore') : _ctx.$t('Base.lessMore'),
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "icon-button",
                          plain: "",
                          icon: showMoreQuery.value ? _unref(ArrowUp) : _unref(ArrowDown),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (showMoreQuery.value = !showMoreQuery.value))
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["content"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onKeyup"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: loadTableData
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "id",
            width: "250",
            label: _ctx.$t('Base.id'),
            fixed: "",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(row.id), 1),
                  _createVNode(LinkOrder, {
                    id: row.orderId,
                    name: `${_ctx.$t('Order.orderID')}:${row.orderId}`
                  }, null, 8, ["id", "name"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "operatorName",
            width: "180",
            label: _ctx.$t('Operation.operator')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(LinkOperator, {
                    id: row.evseOperatorId,
                    name: row.evseOperatorName
                  }, null, 8, ["id", "name"]),
                  _hoisted_10,
                  _createVNode(LinkOperator, {
                    id: row.operatorId,
                    name: row.operatorName
                  }, null, 8, ["id", "name"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            width: "180",
            label: _ctx.$t('Operation.payee')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_tooltip, {
                content: row.walletId,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(row.walletName), 1)
                ]),
                _: 2
              }, 1032, ["content"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "tradeType",
            width: "100",
            label: _ctx.$t('Base.type')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(getProfitSharingTransactionTypeDesc)(row.tradeType)), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(row.amountSource == 0 ? '-' : _unref(getProfitSharingSourceDesc)(row.amountSource)), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "tradeAmount",
            width: "120",
            label: _ctx.$t('Order.tradeAmount')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "fee",
            width: "100",
            label: _ctx.$t('Order.feeAmount')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(row.fee), 1),
                  _createElementVNode("span", _hoisted_18, _toDisplayString((row.feePercentage == 0 ? 0.6 : row.feePercentage * 100).toFixed(2)) + " % ", 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "final",
            width: "100",
            label: _ctx.$t('Order.finallyAmount')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(row.final), 1),
                  _createElementVNode("span", _hoisted_22, _toDisplayString((row.percentage * 100).toFixed(2)) + " % ", 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "state",
            width: "120",
            label: _ctx.$t('Base.state')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(getProfitSharingTradeStateDesc)(row.state)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "afterAmount",
            width: "120",
            label: _ctx.$t('Order.balanceAfterTrade')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "remark",
            "min-width": "150",
            label: _ctx.$t('Base.remark')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "createdAt",
            width: "150",
            label: _ctx.$t('Base.createdAt')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[5] || (_cache[5] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadTableData
        }, null, 8, ["metaData"])
      ])
    ])
  ]))
}
}

})